/**
 * Formats a name from "Lastname, Firstname Middlename" to "Firstname Lastname"
 * @param name The name in "Lastname, Firstname" format
 * @returns The name in "Firstname Lastname" format
 */
export const formatClientName = (name: string | null | undefined): string => {
  if (!name) return 'N/A';
  
  // Check if name contains a comma (indicating Lastname, Firstname format)
  if (name.includes(',')) {
    const parts = name.split(',').map(part => part.trim());
    if (parts.length >= 2) {
      const lastNames = parts[0];
      const firstNames = parts[1];
      return `${firstNames} ${lastNames}`;
    }
  }
  
  // Return as-is if not in expected format
  return name;
};

/**
 * Gets just the first name from a full name
 * @param name The name in any format
 * @returns Just the first name
 */
export const getFirstName = (name: string | null | undefined): string => {
  if (!name) return '';
  
  // First try to format from "Lastname, Firstname" format
  const formatted = formatClientName(name);
  
  // Then get the first word
  const firstSpace = formatted.indexOf(' ');
  return firstSpace > -1 ? formatted.substring(0, firstSpace) : formatted;
};

/**
 * Formats a coach/staff name that might be in various formats
 * @param name The name to format
 * @returns The properly formatted name
 */
export const formatStaffName = (name: string | null | undefined): string => {
  if (!name) return 'N/A';
  
  // Handle names that might have extra spaces or formatting issues
  const cleaned = name.trim().replace(/\s+/g, ' ');
  
  // If it's in "Lastname, Firstname" format, convert it
  if (cleaned.includes(',')) {
    return formatClientName(cleaned);
  }
  
  // Otherwise return the cleaned name
  return cleaned;
};